import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { apiUrl } from "@/lib/api";
import { useAuthStore } from "@/store/authStore";
import { Loader } from "lucide-react";
import { captureException } from "@/lib/analytics";

export const AuthComplete = () => {
  const navigate = useNavigate();
  const [queryParams] = useSearchParams();
  const login = useAuthStore((state) => state.login);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const processLogin = async () => {
      try {
        const sessionToken = queryParams.get("sessionToken");
        if (!sessionToken) {
          setError("No session token provided");
          setTimeout(() => {
            window.location.href = `${apiUrl}/login`;
          }, 2000);
          return;
        }

        // Use our new login function from auth context
        await login(sessionToken);
        // replace so back button never lands on this auth page
        navigate("/", { replace: true });
      } catch (err) {
        captureException(err as Error);
        setError("Failed to login. Please try again.");
      }
    };

    processLogin();
  }, [navigate, queryParams, login]);

  if (error) {
    return (
      <div className="p-4">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          {error}
        </div>
        <p className="mt-2">Redirecting to login page...</p>
      </div>
    );
  }

  return (
    <div className="p-4 flex items-center justify-center h-full">
      <div className="text-center">
        <Loader className="animate-spin" />
      </div>
    </div>
  );
};
